import Request from './Request';
export default class OrbitUserPromptsService {
    /** List saved prompts for the current user. Pass { client_id } to filter. */
    static async list(params = {}) {
        const qs = new URLSearchParams(
            Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        ).toString();
        return Request.get(`/api/orbit/user-prompts${qs ? '?' + qs : ''}`);
    }
    /** Save a new prompt for the current user. */
    static async create(data) {
        return Request.post('/api/orbit/user-prompts', data);
    }
    /** Delete a prompt by id (must be owned by current user). */
    static async delete(id) {
        return Request._delete(`/api/orbit/user-prompts/${id}`);
    }
}
